import React from "react";
import {Link} from "react-router-dom";
import Fade from "react-reveal/Fade"


function OrdinaMobileButton(props){
    if(props.isList){
        return <CompletaOrdineButton openOrderModal={props.openOrderModal}
                                     config={props.config}
                                     liste={props.liste}/>
    }else{
        return <GoToCarrello liste={props.liste} />
    }
}

function CompletaOrdineButton(props){
    let tot_liste = props.liste.reduce((tot, {nElementi}) => tot + nElementi, 0);
    const prezzo = props.liste[0].totPrezzo;
    const visible = tot_liste > 0 && prezzo >= props.config.minimoOrdine;
    return <Fade bottom collapse when={visible}>
        <div id="ordina-button" className="d-flex d-md-none fixed-bottom" onClick={props.openOrderModal}>
              <span className="icon-button">
                <i className="fas fa-paper-plane"></i>
              </span>
            <span className="text-button">CONFERMA L'ORDINE</span>
        </div>
    </Fade>;
}

function GoToCarrello(props){
    let tot_liste = props.liste.reduce((tot, {nElementi}) => tot + nElementi, 0);
    const visible = tot_liste > 0;
    return <Link to={`${process.env.PUBLIC_URL}/riepilogo-ordine`}>
            <Fade bottom collapse when={visible}>
                <div id="ordina-button" className="d-flex fixed-bottom d-md-none">
                  <span className="icon-button">
                    <span className="badge badge-light">{tot_liste}</span>
                  </span>
                    <span className="text-button">ORDINA ORA</span>
                </div>
            </Fade>
        </Link>;

}

export default OrdinaMobileButton;